export {
	AcademyCommonListView, AcademyCommonSettingsView, AcademyOverviewChartView,
	AcademyOverviewSectionView, AcademyReviewHeaderView, AcademyReviewItemView,
	AcademyReviewScoreView, AcademyTestItemView
} from "./impl";
export {
	AcademyView, AcademyView as default, AcademyChartView, AcademyItemView,
	AcademyListView, AcademyScoreView, AcademySectionView, AcademySettingsView
} from "./view";
